module.exports = __webpack_public_path__ + "img/midias-small.4eb9b471.webp";